import { h } from "preact";
import { t, translate } from "restaumatic-client";
function CreatorActions(props) {
    const {} = props;
    return (h("div", { class: "m-product-card__actions" },
        h("button", { class: "m-product-card__action-btn u-btn-unstyled", type: "button", "data-bs-dismiss": "modal", "aria-label": translate(t.theme_defaults.modal.close), "data-field-id": "Creator.close" },
            h("span", { class: "icon-cancel icon-flex-center", "aria-hidden": "true" }))));
}
export default CreatorActions;
